import { gql } from '@apollo/client';

export const GET_DOCTOR_APPOINTMENT_STATISTICS = gql`
  query DoctorAppointmentStatistics {
    doctorAppointmentStatistics {
      data {
        ageGroup
        appointmentsCount
        dateGroup
        gender
      }
    }
  }
`;

export const GET_PAGE_VIEW_COUNT = gql`
  query GetViewCount {
    getViewCount {
      data {
        total
        view_by_country
      }
    }
  }
`;
